<!-- <ion-content> -->
<div class="flex flex-col justify-between h-full gap-3 ion-padding">
  <div class="flex flex-col min-h-60">

    @if (permissionState() !== 'granted') {
      <div class="flex flex-col items-center justify-center gap-3 grow">
        @if(permissionState() === 'requesting'){
          <span class="text-sm text-center">
            <p class="text-gray-600">Please allow camera access to continue</p>
          </span>
        }
      </div>
    }




    @if(permissionState() === 'requesting'){
      <div class="flex flex-col gap-3 grow">
        <hlm-skeleton class="w-full overflow-hidden rounded-lg grow">
          <hlm-skeleton></hlm-skeleton>
        </hlm-skeleton>
      </div>
    }
    

    <webcam class="overflow-hidden rounded-lg grow" [hidden]="permissionState() !== 'granted'"
      (initError)="handleInitError($event)" [trigger]="triggerObservable" (imageCapture)="handleImageCapture($event)"
      [allowCameraSwitch]="true" [mirrorImage]="'always'">
    </webcam>

  </div>


  <div class="flex flex-col gap-4">
    <button hlmBtn variant="destructive" (click)="triggerSnapshot()" [disabled]="!!photo() || permissionState() !== 'granted'">Capture</button>
    <button hlmBtn variant="outline" (click)="closeModal()" >Close</button>
  </div>
</div>
<!-- </ion-content> -->
